import type { OrderStatus } from 'types/order.ts';
import { createStore } from './create-store';

export interface IOrdersFilter {
  statuses?: OrderStatus[];
  withoutMainInvoice?: boolean;
  clientId?: {
    value: number;
    label?: string;
  };
  createdAt?: {
    from: Date;
    to: Date;
  };
  userId?: number;
}

type TState = {
  search: string;
  filters?: IOrdersFilter;
};

type TActions = {
  setSearch: (value: string) => void;
  setFilters: (value: IOrdersFilter | undefined) => void;
};

export const useOrderFiltersStore = createStore<TState & TActions>(
  (set) => ({
    search: '',
    filters: undefined,
    setSearch: (search: string) => set((state) => ({ ...state, search })),
    setFilters: (filters: IOrdersFilter | undefined) => set((state) => ({ ...state, filters })),
  }),
  'order-filters-store',
);
